export default __webpack_public_path__ + "static/media/1982.c98de80d.png";